



























import Vue from "vue";
import {Component, Prop} from "vue-property-decorator";
import EventApi from "../../api/EventsApi";
@Component({
    components: {},
})

export default class SimpleSlider extends Vue {
    @Prop({required: true}) private readonly images!: Array<string>;

    private activeCounter: number = 0;

    mounted(): void
    {
        this.bindEvents();
    }

    beforeDestroy(): void
    {
        this.unbindEvents();
    }

    private prevSlide(): void
    {
        if (!this.activeCounter) {
            return;
        }

        this.activeCounter--;
    }
    private nextSlide(): void
    {
        if (this.activeCounter >= this.images.length - 1) {
            return;
        }

        this.activeCounter++;
    }

    private keyboardEventsHandler(data: any): void
    {
        console.log(data.code);
        if (data.code === 'ArrowRight') {
            this.nextSlide();
        }

        if (data.code === 'ArrowLeft') {
            this.prevSlide();
        }

        if (data.code === 'Escape') {
            this.$emit('close');
        }
    }

    private bindEvents(): void
    {
        EventApi.addEventListener('keyup', this.keyboardEventsHandler.bind(this));
    }

    private unbindEvents(): void
    {
        EventApi.removeEventListener('keyup', this.keyboardEventsHandler.bind(this));
    }
}
